<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">

            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-70 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                    <h2 class="text__colour-teal">Instant Print Order Details</h2>
                    <div class="layout__padding-20-0 text__size-18 text__colour-grey">View details of your instant print order.
                    </div>
                </div>
            </div>
            <div class="layout__padding-clear">


                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <!--<span class="text__colour-teal"> Customer Details </span>-->
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="customerInformation = !customerInformation">
                            <span v-if="this.customerInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.customerInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Customer Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.customerInformation">
                        <p class="text_colour-909399">Contact Name</p>
                        <p>{{this.orderOverview.name}}</p>
                        <br>
                        <p class="text_colour-909399">Contact Email</p>
                        <p>{{this.orderOverview.email}}</p>
                        <br>
                        <p class="text_colour-909399">Branch Code</p>
                        <p>{{this.orderOverview.branch}}</p>
                        <br>
                        <p class="text_colour-909399">Account Type</p>
                        <p><span>Account Customer</span></p>
                        <br>
                        <p class="text_colour-909399">Billing Address</p>
                        <p>{{this.customerDetails.address1}}</p>
                        <p>{{this.customerDetails.address2}}</p>
                        <p>{{this.customerDetails.address3}}</p>
                        <p>{{this.customerDetails.town}}</p>
                        <p>{{this.customerDetails.county}}</p>
                        <p>{{this.customerDetails.postcode}}</p>
                    </div>
                </div>
                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <!--<span class="text__colour-teal"> Customer Details </span>-->
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="orderInformation = !orderInformation">
                            <span v-if="this.orderInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.orderInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Order Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.orderInformation">
                        <p class="text_colour-909399">Order No</p>
                        <p>{{this.orderOverview.orderId}}</p>
                        <br>
                        <p class="text_colour-909399">Order Reference</p>
                        <p>{{this.orderOverview.jobName}}</p>
                        <br>
                        <p class="text_colour-909399">Status</p>
                        <p>{{this.orderOverview.status}}</p>
                        <br>
                        <p class="text_colour-909399">Date</p>
                        <p>{{formatDateDDMMYYYY(this.orderOverview)}}</p>
                    </div>
                </div>

                <div class="component__forms-3">
                    <div class="colour__background-light-grey layout__width-80 layout__padding-10px layout__position-left layout__border__radius-3">
                        <!--<span class="text__colour-teal"> Customer Details </span>-->
                        <div class="layout__cursor-pointer text__size-14 text__colour-teal layout__position-left layout__padding__right-20px"
                             v-on:click="paymentInformation = !paymentInformation">
                            <span v-if="this.paymentInformation === false"
                                  class="icon-plus layout__padding__right-20px"></span>
                            <span v-if="this.paymentInformation !== false"
                                  class="icon-minus layout__padding__right-20px"></span>
                            <span class="text__colour-teal"> Payment Details </span>
                        </div>
                    </div>
                    <div class="layout__position-left layout__width-100 layout__padding-5px"
                         v-show="this.paymentInformation">
                        <p class="text_colour-909399">Subtotal (ex. VAT)</p>
                        <p>£{{this.orderOverview.billNetTotal}}</p>
                        <br>
                        <p class="text_colour-909399">VAT</p>
                        <p>£{{this.orderOverview.billVatTotal}}</p>
                        <br>
                        <p class="text_colour-909399">Total (inc. VAT)</p>
                        <p>£{{this.orderOverview.billGrossTotal}}</p>
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__padding-20-0">

                <el-table :data="order">
                    <el-table-column label="Artwork Dimensions">
                        <template slot-scope="props">
                            <div>
                                {{props.row.printJobSpec.pageWidth}} x {{props.row.printJobSpec.pageHeight}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="printJobSpec.name" label="Product">
                    </el-table-column>
                    <el-table-column prop="printJobSpec.stockType" label="Paper Type">
                    </el-table-column>
                    <el-table-column prop="printJobSpec.stockWeight" label="Paper Weight">
                    </el-table-column>
                    <el-table-column label="Lamination" width="180">

                        <template slot-scope="props">
                            <span v-if="props.row.printJobSpec.lamination === 'GLOSS LAM'">Gloss Lamination</span>
                            <span v-if="props.row.printJobSpec.lamination === 'MATT LAM'">Matt Lamination</span>
                            <span v-if="props.row.printJobSpec.lamination !== 'GLOSS LAM' && props.row.printJobSpec.lamination !== 'MATT LAM'">No Lamination</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="printJobSpec.quantity" label="Quantity">
                    </el-table-column>
                </el-table>
            </div>

        </div>
    </div>

</template>

<script>
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';

    export default {
        name: "JobDetails",
        mixins: [axios, dataFormatter],
        created() {

            this.id = this.$route.query.id
            console.log(this.id)
            // this.orderOverview = this.$route.query.orderOverview
            console.log(this.orderOverview)

            if (typeof this.orderOverview === 'undefined') {
                if (window.sessionStorage.getItem('_instantprint') !== null) {
                    this.orderOverview = JSON.parse(window.sessionStorage.getItem('_instantprint'))

                    console.log(this.orderOverview)
                }
            }

            // todo may have to call other bits to pull the full order and customer and billing details

            // todo pull the billing details from the same place as the app
            // const customer = JSON.parse(this.returnCookie("_customer"))

            const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Orders/` + this.id

            // const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Orders/2851`

            console.log(url)

            Axios.get(url, this.returnHeaderUsingToken())
                .then(response => {

                    console.log('photofixr order information')
                    console.log(response)
                    this.order = response.data

                    console.log(this.order)

                });

            const customerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/FindByRef?customerRef=` + this.orderOverview.branch

            // const customerUrl = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Customer/FindByRef?customerRef=XXX1`
            console.log(customerUrl)
            Axios.get(customerUrl, this.returnHeaderUsingToken())
                .then(response => {
                    this.customerDetails = response.data.result
                })
        },
        methods: {},
        beforeUpdate() {
            window.sessionStorage.setItem('_instantprint', JSON.stringify(this.orderOverview));
        },
        data() {
            return {
                order: [],
                customerDetails: {},
                customerInformation: true,
                orderInformation: true,
                paymentInformation: true
            }
        },
        props: {
            orderOverview: {},
        }
    };
</script>